import { DesignStudioInboxPreviewsRoute } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/design-studio_/_editor/editor/$id_/inbox-previews/$runId',
)({
  component: DesignStudioInboxPreviewsRoute,
});
